import { Button, Grid, Typography } from '@mui/material';

export const Success = () => {
  return (
    <Grid
      container
      alignItems="center"
      direction="column"
      justifyContent="center"
      style={{ height: '15rem' }}
    >
      <Grid item>
        <Typography
          variant="h4"
          component="div"
          gutterBottom
          sx={{ fontSize: '17px' }}
        >
          Thank you for submitting your form!
        </Typography>
      </Grid>
      <Grid item>
        <Button href="https://futureinrealestate.realtor" variant="contained">
          Find a Future in Real Estate
        </Button>
      </Grid>
    </Grid>
  );
};
